import { AlertTriangle, Inbox, RefreshCw } from 'lucide-react';

interface FeedbackStateProps {
    type: 'error' | 'empty';
    title: string;
    message: string;
    onAction?: () => void;
    actionLabel?: string;
}

export function FeedbackState({
                                  type,
                                  title,
                                  message,
                                  onAction,
                                  actionLabel
                              }: FeedbackStateProps) {
    const isError = type === 'error';

    const config = {
        error: {
            icon: AlertTriangle,
            iconBg: 'bg-red-100',
            iconColor: 'text-red-600',
            borderColor: 'border-red-200',
            bgColor: 'bg-red-50',
            titleColor: 'text-red-900',
            messageColor: 'text-red-700',
            buttonBg: 'bg-red-600 hover:bg-red-700',
            buttonText: 'text-white'
        },
        empty: {
            icon: Inbox,
            iconBg: 'bg-gray-100',
            iconColor: 'text-gray-400',
            borderColor: 'border-gray-200',
            bgColor: 'bg-gray-50',
            titleColor: 'text-gray-900',
            messageColor: 'text-gray-600',
            buttonBg: 'bg-gray-600 hover:bg-gray-700',
            buttonText: 'text-white'
        }
    };

    const style = config[type];
    const Icon = style.icon;

    return (
        <div className={`rounded-xl border ${style.borderColor} ${style.bgColor} p-8 md:p-12`}>
            <div className="flex flex-col items-center text-center max-w-md mx-auto">
                {/* Ícone */}
                <div className={`${style.iconBg} p-4 rounded-2xl mb-4`}>
                    <Icon className={`h-8 w-8 ${style.iconColor}`} />
                </div>

                {/* Título */}
                <h3 className={`text-lg font-bold ${style.titleColor} mb-2`}>
                    {title}
                </h3>

                {/* Mensagem */}
                <p className={`text-sm ${style.messageColor} mb-6`}>
                    {message}
                </p>

                {/* Botão de ação */}
                {onAction && (
                    <button
                        onClick={onAction}
                        className={`inline-flex items-center gap-2 px-5 py-2.5 ${style.buttonBg} ${style.buttonText} rounded-lg font-medium transition-colors shadow-sm`}
                    >
                        {isError && <RefreshCw className="h-4 w-4" />}
                        {actionLabel || (isError ? 'Tentar Novamente' : 'Recarregar')}
                    </button>
                )}
            </div>
        </div>
    );
}